import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { GetPostsResumosExtendido } from '../../services/servicesGetPostsResumoExtendido';
import { DivConteudo, DivMain } from './styleCategorias';
import { URLIMG } from '../../helpers/constantes';
import ButtonTrialVersion from '../../components/ButtonTrialVersion/ButtonTrialVersion';
export default function Categorias(props) {
    const location = useLocation();
    const history = useHistory();
    const [categoria, setCategoria] = useState(window.location.href.split('/'));
    const [nomeCategoria, setNomeCategoria] = useState(decodeURIComponent(categoria[categoria.length - 1]));
    const [dadosCategoria, setDadosCategoria] = useState([]);
    const [urlImg, setUrlImg] = useState(URLIMG);

    function redirectURL({ pathname, state }) {
        history.push(pathname)
        location.pathname = pathname
    }
    async function carregaCategoria() {
        let dados = await GetPostsResumosExtendido();
        if (nomeCategoria === "Mais Compartilhados") {
            try {
                const arrayCategoria = [];
                dados.forEach(item => {
                    if (item.Category.toLowerCase().includes('populares')) {
                        arrayCategoria.push(item)
                    }
                })
                setDadosCategoria(arrayCategoria);
                return
            } catch (error) {
                console.log(error);
            }
        } else {
            if (nomeCategoria !== '') {
                try {
                    const arrayCategoria = [];
                    dados.forEach(item => {
                        if (item.Category.includes(nomeCategoria)) {
                            arrayCategoria.push(item)
                        }
                    })
                    setDadosCategoria(arrayCategoria);
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }

    useEffect(() => {
        carregaCategoria();
    }, [props.location]);

    return (<DivMain>
        <ButtonTrialVersion />
        <h1 style={{ cursor: 'default', margin: '20px 0  0 20px' }}>
            {nomeCategoria === 'Exclusivos' ?
                'Não publicados'
                :
                nomeCategoria === 'Populares' ?
                    'Mais Compartilhados'
                    :
                    nomeCategoria
            }
        </h1>
        <DivConteudo>
            {dadosCategoria.map((item) => {
                return (<div key={item.Id} style={{ display: 'flex', cursor: 'pointer' }} onClick={() => redirectURL({ pathname: `/app/postedit/${item.Id}` })}>
                    <img
                        // onError={(event)=>{VerificaUrlCorreta(event.currentTarget)}}
                        src={`${urlImg + item.Image1.split('/')[item.Image1.split('/').length - 1]}`} />
                </div>)
            })}
        </DivConteudo>


    </DivMain>)
}

